export enum zIndexGeneral {
  ContextMenu = 1300,
  ModalOverlay = 10000,
  PopperTooltip = 10001,
  OverlayLayer = 10,
}
